import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
// import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import MyStore from 'kts-platform-frame/redux/MyStore';
import { connect, reducers } from 'kts-platform-frame/redux';
import { mediaUrl } from 'kts-platform-frame/entry/configUtils';
import Authority from './UI.Authority';
import { Card, Button, Row, Col, Divider, Modal, message, Icon, Checkbox } from 'antd';
const appDefault = require('../img/appDefault.png');

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    nickName?: string;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    nickName: state.user.userInfo.nickName
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentWillUnmount() {
        ModulesAction.closeShowPanel();
    }
    render() {
        const backBt = <Button size="small" onClick={this.goBack}>返回</Button>;
        const appInfo = this.modulesState.appInfo;
        const imgHost = mediaUrl();
        const isReadCheckd = this.modulesState.isReadCheckd;
        return (
            <div className={css.appInfo}>
                {/* 激活提示 */}
                {
                this.modulesState.activTipsM &&
                <Modal
                    title={null}
                    visible={this.modulesState.activTipsM}
                    width={'700px'}
                    footer={null}
                    className={css.infoTipsM}
                    bodyStyle={{height: '350px'}}
                    onCancel={()=> {
                        ModulesAction.activeTipsM(false);
                    }}
                >
                    <div className={css.infoTipsContent}>
                        <div className={css.infoTipsMTitle}>激活提示</div>
                        <div className={css.infoTipsMContent}>
                            接受许可以激活! {
                                this.modulesState.appCategories.map(item => {
                                    return (<span key={item.apiCategoryId}>&nbsp;/&nbsp; 该应用会访问{item.apiCategoryName}</span>);
                                })
                            }
                        </div>
                        <div className={css.infoTipsMTitle}>用户协议</div>
                        <div className={css.infoTipsMContent}>
                            <div dangerouslySetInnerHTML={{ __html: this.modulesState.appAgreementContent }} />
                        </div>
                    </div>
                    <div className={css.infoTipsFooter}>
                        <div className={css.infoTipsFooterCheck}>
                                <Checkbox value={isReadCheckd} onChange={ModulesAction.onChangeCheck}> 
                                    <span className={css.readAgree}>我已阅读并同意。</span>
                                </Checkbox>
                        </div>
                        <div className={css.infoTipsFooterSubmit}>
                            <Button type="link" disabled={!isReadCheckd} onClick={() => ModulesAction.appInstanceActivate(this.modulesState.appInfo.appId)} className={css.footerBts}>
                                确定
                            </Button>
                                <Button type="link" className={css.footerBts} onClick={() => ModulesAction.activeTipsM(false)}>
                                取消
                            </Button>
                        </div>
                    </div>
                </Modal>
                }
                <Card title="应用详情" extra={backBt}>
                    <div className={css.infoContent}>
                        <Row style={{ padding: '26px 0' }}>
                            <Col span={5}>
                                <div className={css.imgBlock}>
                                    {
                                        appInfo.appIcon ? <img src={imgHost + appInfo.appIcon} /> : <img src={appDefault} />
                                    }
                                </div>
                            </Col>
                            <Col span={19} style={{ padding: '0 20px' }}>
                                <div className={css.baseInfoName}>{appInfo.appName}</div>
                                <div className={css.baseInfoDs}>{appInfo.appDescription}</div>
                                {/* <div className={css.baseInfoType}>免费</div> */}
                                <div className={css.baseInfoType}>
                                    {appInfo.categoryName && appInfo.categoryName.replace(/,/g, ' ')} | 由 {appInfo.appCompany} 开发
                                </div>
                                <div className={css.baseInfoBts}>
                                    {
                                        appInfo.isActivated === 1 ?
                                            (
                                                <div>
                                                    {/* <Button size="small" onClick={() => { ModulesAction.updateDisabledModal(true); }} className={css.btActi}>禁用</Button> */}
                                                    {appInfo.appType !== 1 && <Button size="small" onClick={() => { this.onShowPanel(appInfo.appId); }} className={css.btSetAuth}>设置权限</Button>}
                                                </div>
                                            )
                                            :
                                            (
                                                <div>
                                                    {/* <Button size="small" onClick={() => { ModulesAction.isActivate(appInfo.appId); }} className={css.btActi}>激活</Button> */}
                                                    {appInfo.appType !== 1 && <Button size="small" disabled={true} style={{ fontSize: '12px' }}>设置权限</Button>}
                                                </div>
                                            )
                                    }
                                </div>
                            </Col>
                        </Row>
                        {
                            appInfo.appType === 1 && <div>
                                <Divider />
                                <div>
                                    <p className={css.infoDetailTitle}>操作人: <span style={{ color: '#999999' }}>{this.props.nickName}</span></p>
                                </div>
                                <Divider />
                                <div>
                                    <p className={css.infoDetailTitle}>appKey: <span style={{ color: '#999999' }}>{this.modulesState.appInfo.appKey}</span></p>
                                    <p className={css.infoDetailTitle}>appSecret: <span style={{ color: '#999999' }}>{this.modulesState.appInfo.appSecret}</span></p>
                                </div>
                                <Divider />
                                <div>
                                    <p className={css.infoDetailTitle}>
                                        <span>应用秘钥</span>
                                        {appInfo.appType === 1 && false && <a href="javascript:;" className={css.refresh} onClick={ModulesAction.reFresh}>刷新秘钥</a>}
                                    </p>
                                    <div className={css.infoDetailContent}>
                                        <div className={css.cont}>
                                            <div className={css.sTitle}>AK</div>
                                            <div className={css.sDetails}>{this.modulesState.appInfo.appInstanceAK}</div>
                                            {this.modulesState.appInfo.appInstanceAK && <Button onClick={() => this.copy('appInstanceAK')}>复制</Button>}
                                        </div>
                                        <div className={css.cont}>
                                            <div className={css.sTitle}>SK</div>
                                            <div className={css.sDetails}>{this.modulesState.appInfo.appInstanceSK}</div>
                                            {this.modulesState.appInfo.appInstanceSK && <Button onClick={() => this.copy('appInstanceSK')}>复制</Button>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <Divider />
                        <div>
                            <p className={css.infoDetailTitle}>应用简介</p>
                            <div className={css.infoDetailContent}>
                                {appInfo.appIntroduction}
                            </div>
                        </div>
                        {/* <Divider />
                        <div>
                            <p className={css.infoDetailTitle}>新功能</p>
                            <div className={css.infoDetailContent}>
                                1 - 开启更加个性化、更具针对性的店内体验。获得有关产品和课程的建议，查看个人收藏中的商品是否有现货，以及扫描配件以确认兼容性和了解产品信息。
                                2 - 使用课程标签页，查看每日的摄影、音乐以及更多课程，进一步发掘你的创造力。另外，还可以根据你拥有的产品选择课程。
                                3 - 订单管理的方式更加多样化。现在可以查看发票、编辑送货详情和镌刻赠言，或取消订单中的单件商品。
                            </div>
                        </div> */}
                        <Modal
                            title="提示"
                            visible={this.modulesState.disabledModal}
                            onOk={() => {
                                ModulesAction.prohibit(appInfo.appId);
                                ModulesAction.updateDisabledModal(false);
                            }}
                            onCancel={() => {
                                ModulesAction.updateDisabledModal(false);
                            }}
                            className='kts-app-ant-modal'
                        >
                            <p style={{ display: 'flex', alignItems: 'center' }}><Icon type="zhuyi" style={{ color: '#ffb301', fontSize: '24px', marginRight: '12px' }} />禁用后公司其他协作成员将不能使用此应用!</p>
                        </Modal>
                    </div>
                </Card>
            </div>
        );
    }
    /**
     * 添加权限 侧边栏展开
     */
    onShowPanel = (appId: number) => {
        MyStore.instance.dispatch(reducers.aside.ActionTypes.show, {
            Components: <Authority />,
            title: '设置权限'
        });
    }
    /** 返回 */
    private goBack = (): void => {
        this.props.history.goBack();
    }
    /** 禁用应用 */
    private prohibit(appId: number) {
        Modal.confirm({
            title: '提示',
            content: '禁用后公司其他协作成员将不能使用此应用!',
            onOk: () => {
                ModulesAction.prohibit(appId);
            },
        });
    }
    /** 复制 */
    private copy = (name) => {
        const input = document.createElement('input');
        document.body.appendChild(input);
        input.setAttribute('value', this.modulesState.appInfo[name]);
        input.select();
        if (document.execCommand('copy')) {
            document.execCommand('copy');
            message.success('复制成功！');
        }
        document.body.removeChild(input);
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppDetail/UI.AppInfo.tsx